module.exports = "./img/d10ea96f76b4286fc631403ba52fb59a.jpg";